// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;God has spoken in his holiness:&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;&#145;I will triumph and divide Shechem,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and share out the valley of Succoth.<br> </p> </div></div>";
// Exports
module.exports = code;